/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_Recurrence_Until_Before_StartInputs */

const vi_error_work_activity_recurrence_until_before_start = /** @type {(inputs: Error_Work_Activity_Recurrence_Until_Before_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày lặp đến phải từ ngày bắt đầu trở về sau.`)
};

/**

* @param {Error_Work_Activity_Recurrence_Until_Before_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_recurrence_until_before_start = /** @type {((inputs?: Error_Work_Activity_Recurrence_Until_Before_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_Recurrence_Until_Before_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_recurrence_until_before_start(inputs)
});